import Swiper, { Lazy, Navigation, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-story-carousel]',
};

// const classes = {
//   swiperPagination: '.swiper-pagination',
// };

class StoryCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      this.breakpoint = window.matchMedia('(max-width:767px)');

      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    if (this.breakpoint.matches === true) {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        modules: [Lazy, Navigation, Pagination],
        lazy: true,
        // freeMode: true,
        slidesPerView: 1.1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // pagination: {
        //   el: classes.swiperPagination,
        //   clickable: true,
        // },
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('story-carousel', StoryCarousel);
